import * as React from 'react'
import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import AppDialog, { ModalActions } from '@/components/CustomModal'
import { useSendTrialWinbackAllMutation } from '@/hooks/usePlatformCampaigns'

export function SendTrialWinbackAllButton({
  pendingCount,
}: {
  pendingCount: number
}) {
  const [open, setOpen] = React.useState(false)
  const mut = useSendTrialWinbackAllMutation()

  const submit = async () => {
    try {
      const res = await mut.mutateAsync()
      toast.success('Campagne envoyée', {
        description: `${res.sent} envoyé(s), ${res.failed} échec(s), ${res.skipped} déjà relancé(s)`,
      })
      setOpen(false)
    } catch (e: unknown) {
      const description =
        (e as { response?: { data?: { message?: string } } })?.response?.data
          ?.message ?? 'Erreur inconnue'
      toast.error('Envoi impossible', { description })
    }
  }

  return (
    <AppDialog
      open={open}
      onOpenChange={setOpen}
      title='Envoyer à tous les éligibles'
      description={`Cette action va envoyer l'email de relance à ${pendingCount} owner(s) qui n'ont pas encore été contacté(s).`}
      trigger={
        <Button
          variant='outline'
          size='sm'
          disabled={pendingCount === 0}
          onClick={() => setOpen(true)}
        >
          Envoyer à tous les éligibles ({pendingCount})
        </Button>
      }
      footer={
        <ModalActions
          cancelLabel='Annuler'
          confirmLabel='Envoyer'
          confirmLoading={mut.isPending}
          confirmDisabled={mut.isPending || pendingCount === 0}
          onConfirm={submit}
        />
      }
    >
      <p className='text-sm text-muted-foreground'>
        Les owners déjà relancés sont automatiquement ignorés.
      </p>
    </AppDialog>
  )
}
